import { getBusinesses } from '../../../data/repositories/businessRepository.js';
import { transformBusinessForMap } from './transformBusinessForMap.js';

export const filterBusinessesByCategoryForMap = async (categoryIds, page = 1, take = 1000) => {
    const params = { page: String(page), take: String(take), categoryIds };
    const result = await getBusinesses(params);
    const businesses = result.data || [];
    return {
        businesses: businesses.map(transformBusinessForMap),
        hasNext: result.meta?.hasNext || false,
    };
};
